import moment from "moment";
import { adddocumentary,followOrderType, TraceType } from "@/server/api.js";
import { Toast } from "vant";
export default {
    data() {
        return {
            filter: {
                type: '',
                remark: '',
                stair: '',
                foxbase: '',
                threeLevel: '',
                createtime: '',
                planstudytime: ''
            },
            typeName: '',
            typedname: "",//学员类型input字段
            typedid: "",
            onelevelName: '',
            twolevelName: '',
            thrlevelName: '',
            zsZhiliang:'',//学员质量id选中
            studentZhiLiang:'',//学员质量描述
            remark: "",
            username: "",
            nexttracetime: "",
            planstudytime: "",
            columnsType: [],//学员类型列表
            columnsZhiLiang: [],//学员质量列表
            showPicker: false,//学员类型弹框开关
            showPickerZhiLiang:false,//学员质量开关
            showCalendar: false,//
            planCalendar: false,//预计学习弹框开关
            nextCalendar: false,//下次跟单弹框开关
            oneColumn: [], // 一级数组
            twoColumn: [],
            thirColumn: [],
            showPickerFirstLevel:false,//一级分类开关
            showPickerSecondLevel:false,//一级分类开关
            showPickerThirdLevel:false,//一级分类开关
            routeParams: {},
            zsUserid: localStorage.getItem("zsUserId"),//当前登录者userid

        };
    },
    async mounted() {
        await this.getTracelist();
        this.partStudentTraceType()
        if(this.$route.path==='/quicklyOrder'){
          await this.studentZhiL();
        }
        this.routeParams = this.$route.query;
    },
    methods: {
        //学员类型
        async getTracelist() {
          let res = await followOrderType({id:74});
          if(res.code !=='200') return Toast.fail(res.msg);
          this.columnsType = [...res.data];
          this.filter.type = res.data[0].did
          this.typeName = res.data[0].dname
        },
        //学员质量
        async studentZhiL() {
            let res = await followOrderType({id:5354});
            if(res.code !=='200') return Toast.fail(res.msg);
            this.columnsZhiLiang = [...res.data.reverse()];
        },
        //三级分类
        async partStudentTraceType() {
            this.oneColumn = await this.lavelType(0)
        },
        async lavelType(num) {
            let data = []
            let res = await TraceType(num);
            if(res.code !=='200') return Toast.fail(res.msg);
            data = res.data
            return data
        },
        onSubmit() {
            let params = {
                askid: this.routeParams.askId,
                // kefuid: this.routeParams.kefuId,
                kefuid: +this.zsUserid
            };
            // http://localhost:8080/addRecord?askId=3770425&kefuId=17185
            adddocumentary({...params, ...this.filter}).then((res) => {
                if (res.code !== "200") return Toast.fail(res.msg);
                Toast.success("添加成功");
                this.$router.push({name: "Info",params: {tabname: 'recodeInfo'}});
            });
        },
        //学员类型选择确认
        onConfirmStudentType(value) {
            this.typeName = value.dname;
            this.filter.type = value.did;
            this.showPicker = false;
        },
        //学员质量选择确认
        onConfirmZhiLiang(value){
            this.studentZhiLiang = value.dname;
            this.zsZhiliang = value.did;
            this.showPickerZhiLiang = false;
        },
        //下次跟单确认选择
        nextonConfirm(date) {
            this.filter.createtime = moment(date).format("YYYY-MM-DD");
            this.nextCalendar = false;
        },
        //预计学习时间
        dateonConfirm(date) {
            this.filter.planstudytime = moment(date).format("YYYY-MM-DD");
            this.planCalendar = false;
        },
        //一级分类
        async onConfirmFirstLevel(val){
            this.showPickerFirstLevel = false;
            this.filter.stair = val.id;
            this.onelevelName = val.typeName

            this.filter.foxbase = '';
            this.twolevelName = ''
            this.twoColumn = []
            this.twoColumn = await this.lavelType(val.id)

            this.filter.threeLevel = '';
            this.thrlevelName = ''
            this.thirColumn = []
        },
        async onConfirmSecondLevel(val){
            this.showPickerSecondLevel = false;
            this.filter.foxbase = val.id;
            this.twolevelName = val.typeName

            this.filter.threeLevel = '';
            this.thrlevelName = ''
            this.thirColumn = []
            this.thirColumn = await this.lavelType(val.id)
        },
        onConfirmThirdLevel(val){
            this.showPickerThirdLevel = false;
            this.filter.threeLevel = val.id;
            this.thrlevelName = val.typeName
        },

        //提交成功跳转
        backLink() {
            this.$router.push({name:"Info",params: {tabname: 'recodeInfo'}});
        },
    },
};
